import { render, staticRenderFns } from "./mihub-validate.vue?vue&type=template&id=1220effe&scoped=true&"
import script from "./mihub-validate.vue?vue&type=script&lang=js&"
export * from "./mihub-validate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1220effe",
  null
  
)

export default component.exports